import { cn } from '@/lib/cn';
import { initials } from '@/lib/format';

interface AvatarProps {
  name?: string | null;
  src?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  xs: 'h-5 w-5 text-[9px]',
  sm: 'h-7 w-7 text-[11px]',
  md: 'h-9 w-9 text-caption',
  lg: 'h-12 w-12 text-body-strong',
};

export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const cls = cn(
    'inline-flex items-center justify-center rounded-full overflow-hidden',
    'bg-canvas-hover text-navy font-semibold',
    sizes[size],
    className,
  );
  if (src) {
    return <img className={cls} src={src} alt={name ?? 'avatar'} />;
  }
  return <span className={cls}>{initials(name)}</span>;
}
